/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import get from "lodash/get";
import PropTypes from "prop-types";
import React from "react";
import TimeAgo from "react-timeago";
import { formatter } from "../../../isomorphic/utils";
import { ShowReadTime } from "../atoms/read-time/index";
import { AuthorsImageList, AuthorsNameList, dateFormatter, getTimeStampOptions } from "./utils";

export function MultipleAuthorTemplate({
  textStory,
  liveBlog,
  listicleStory,
  authors = [],
  showDateOnly = false,
  hideImage = false,
  isLink,
  authorNameKeyword,
  storyPubKeyword,
  date,
  readTime,
  config = {}
}) {
  const options = getTimeStampOptions(config);
  const showRelativeTime = get(config, ["theme-attributes", "story-timeformat"])
    ? get(config, ["theme-attributes", "story-timeformat"]) === "relativetime"
    : false;
  const timeZone = get(config, ["theme-attributes", "story-timeformat"], "");
  const publishedAt = new Date(date).toLocaleString("en-US", options);
  const getTimeStamp =
    textStory === "hero-overlay" ? (
      <TimeAgo
        date={date}
        formatter={(value, unit, suffix, date, defaultFormatter) =>
          formatter(value, unit, suffix, date, defaultFormatter)
        }
        title={null}
      />
    ) : (
      <TimeAgo date={date} formatter={date => dateFormatter(date)} title={null} />
    );
  const authorsLength = authors.length;
  const publishKeyword = !showDateOnly ? "Published on : " : "";
  const readTimeCustomClass =
    (textStory || liveBlog || listicleStory) === "hero-overlay" ? "read-time-overlay" : "read-time-default";

  return (
    <div className="author author--multiple">
      <div className="author__avatars">{!hideImage && <AuthorsImageList authors={authors} isLink={isLink} />}</div>
      <div className="author__content">
        {authorNameKeyword}
        <AuthorsNameList authors={authors} authorsLength={authorsLength} isLink={isLink} />
        <div className={`author__published-date ${textStory === "hero-overlay" ? "time-wrapper" : ""}`}>
          {storyPubKeyword || (publishKeyword && <span className="pub-keyword">{publishKeyword}</span>)}
          {showRelativeTime ? (
            <div className="author__time-stamp-wrapper">{getTimeStamp}</div>
          ) : (
            <div className="author__time-stamp-wrapper">
              <time dateTime={new Date(date).toISOString()}>
                {publishedAt} {timeZone !== "relativetime" ? timeZone : ""}
              </time>
            </div>
          )}
          <ShowReadTime storyReadTime={readTime} customCssClasses={readTimeCustomClass} />
        </div>
      </div>
    </div>
  );
}

MultipleAuthorTemplate.propTypes = {
  textStory: PropTypes.string,
  liveBlog: PropTypes.string,
  listicleStory: PropTypes.string,
  authors: PropTypes.array,
  showDateOnly: PropTypes.bool,
  hideImage: PropTypes.bool,
  isLink: PropTypes.bool,
  authorNameKeyword: PropTypes.string,
  storyPubKeyword: PropTypes.string,
  date: PropTypes.string,
  readTime: PropTypes.number,
  config: PropTypes.object
};
